import React, {Fragment, useEffect, useState} from "react" ;

const AppSidebarGroup = (props) =>
{
    const [selected, setSelected] = useState(props.default );

    useEffect(()=>{
        setSelected( props.default ) ;
    }, [props.default]);

    const isActive = (myTag) =>
    {
        return myTag === selected;
    }

    const onMenuItemClick = (item) =>
    {
        setSelected(item);
    }

    const renderChildren = () =>
    {
        if (React.Children !== undefined)
        {
            return React.Children.map(props.children, child =>
            {
                if (React.isValidElement(child))
                {
                    return React.cloneElement(child, {onClick: onMenuItemClick, active: isActive(child.props.name)});
                }
            })
        }
    }

    return (
        <Fragment key='section'>
            <li className="dt-module-side-nav__header">
                <span className="dt-module-side-nav__text">{props.title}</span>
            </li>
            {renderChildren()}
        </Fragment>
    );
}

export default AppSidebarGroup;
